const CSS_COLORS_CLASSES = {
  TAG_ROOT_PRIMARY: "tag-root-primary",
  TAG_ROOT_SECONDARY: "tag-root-secondary",
  TAG_ROOT_INTERACTIVE: "tag-root-interactive",
  TAG_ROOT_ACCENT: "tag-root-accent",
  TAG_ROOT_ERROR: "tag-root-error",
  TAG_ROOT_WARNING: "tag-root-warning",
  TAG_ROOT_SUCCESS: "tag-root-success",
  TAG_ROOT_GRAY: "tag-root-gray",
};

const CSS_SIZES_CLASSES = {
  TAG_ROOT_LARGE: "tag-root-large",
  TAG_ROOT_SMALL: "tag-root-small",

  TAG_TEXT_LARGE: "tag-text-large",
  TAG_TEXT_SMALL: "tag-text-small",
};

export const CSS_CLASSES = {
  TAG_ROOT: "tag-root",
  TAG_ROOT_INVERTED: "inverted",
  TAG_ROOT_DISABLED: "tag-root-disabled",
  TAG_BUTTON: "tag-button",
  TAG_BUTTON_ICON: "tag-button-icon",
  TAG_TEXT: "tag-text",
  TAG_ICON: "tag-icon",
  TAG_ICON_START: "tag-icon-start",
  TAG_ICON_END: "tag-icon-end",
  ...CSS_COLORS_CLASSES,
  ...CSS_SIZES_CLASSES,

  TAG_LIST_ROOT: "tag-list",
};
